import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import {Observable} from 'rxjs';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';

import {UtilConfig} from './UtilConfig';


@Injectable()
export class AuthService {
    token: string;
    URL_WS_LOGIN = '/auth';
    URL_WS_UNLOCK = '/unlock';
    URL_RECUPERAR_CLAVE = '/restorePassword'; //Genera correo con link para hacer el reset
    URL_WS_FIND_BY_TOKEN = '/findByToken/';
    URL_RESET_CLAVE = '/resetPassword'; //Realiza el reset de la clave

    constructor(private http: Http,
                private jwtutil: UtilConfig) {
    }

    login(username: string, password: string, ruc: string): Observable<boolean> {
        const url = this.jwtutil.URL_WS_BACKEND + this.URL_WS_LOGIN;
        const headers = new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});
        const params = 'username=' + username + '&password=' + password + '&ruc=' + ruc + '&authenticationType=WEB';
        return this.http.post(url, params, {headers: headers})
            .map((response: Response) => {

                // login successful if there's a jwt token in the response
                const token = response.json() && response.json().token;
                if (token) {
                    // se asigna el token
                    this.token = token;
                    this.jwtutil.setCurrentUser(response.json().usuario);
                    this.jwtutil.setJwtToken(this.token);
                    // return true  indicando un login exitoso
                    return true;
                } else {
                    // return false to indicate failed login
                    return false;
                }
            });
    }

    unlock(username: string, password: string, ruc: string): Observable<boolean> {
        const url = this.jwtutil.URL_WS_BACKEND + this.URL_WS_UNLOCK;
        const headers = new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});
        const params = 'username=' + username + '&password=' + password + '&ruc=' + ruc;
        return this.http.post(url, params, {headers: headers})
            .map((response: Response) => {

                // login successful if there's a jwt token in the response
                const token = response.json() && response.json().token;
                if (token) {
                    // se asigna el token
                    this.token = token;
                    // almacenamos username and jwt token en localstorage manteniendonos logeados entre paginas
                    // TODO MODIFICAR
                    this.jwtutil.setCurrentUser(response.json().usuario);
                    this.jwtutil.setJwtToken(this.token);
                    // return true  indicando un login exitoso
                    return true;
                } else {
                    // return false to indicate failed login
                    return false;
                }
            });
    }

    logout(): void {
        // clear token remove user from local storage to log user out
        this.token = null;
    }

    lockScreen(url): void {
        // clear token remove user from local storage to log user out
        this.jwtutil.saveUrl(url);
        this.token = null;
        this.jwtutil.removeJwtToken();
    }

    loggedIn() {
        this.token = this.jwtutil.getJwtToken();
        return (this.token != null);
    }

    recuperarClave(correo: number, pruc: string): Observable<any> {
        const url = this.jwtutil.URL_WS_BACKEND + this.URL_RECUPERAR_CLAVE;
        const usuarioVar = {username: correo};
        const body = JSON.stringify({usuario: usuarioVar, ruc: pruc});
        const headers = new Headers({'Content-Type': 'application/json; charset=UTF-8'});

        return this.http.post(url, body, {headers: headers})
            .map(res => {
                this.jwtutil.setJwtToken(res.json().token);
                return res.json();
            })
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }

    findByToken(token: string): Observable<any> {
        const url = this.jwtutil.URL_WS_BACKEND + this.URL_WS_FIND_BY_TOKEN + token;
        const headers = new Headers({'Content-Type': 'application/json; charset=UTF-8'});
        return this.http.get(url, {headers: headers}).catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }

    resetClave(user: string, pruc: string, clave: string): Observable<any> {
        const url = this.jwtutil.URL_WS_BACKEND + this.URL_RESET_CLAVE;
        const usuarioVar = {username: user, clave: clave};
        const body = JSON.stringify({usuario: usuarioVar, ruc: pruc});
        const headers = new Headers({'Content-Type': 'application/json; charset=UTF-8'});

        return this.http.post(url, body, {headers: headers})
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }

}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/autenticacion/servicios/auth.service.ts